/**
 * Created by theodora on 6/12/14.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var SV = require('server-vars');
var authModalLoader = require('../../../auth/authModalLoader').default;
var parseUri = require('../../../global/utils/commonjs/uri').URL;
var helpers = require('./navHelpers');
var User = require('../../../global/models/User');

var authModals = [
    authModalLoader.constants.LOGIN,
    authModalLoader.constants.REGISTER,
    authModalLoader.constants.RESET_PASSWORD,
    authModalLoader.constants.RESET_INVALID
];

/**
 *
 * @param uri
 * @returns {string}
 */
var getRedirectDestination = function (uri) {
    var queryKey = uri.queryKey;
    var dest = queryKey.ep ? decodeURIComponent(queryKey.ep) : null;
    if (dest && dest.indexOf('//') > -1) {
        // id ep contains '//' then redirect to current page
        // if phishing is happening, just redirect to the homepage (uri.path = '/')
        dest = uri.path;
    }

    return dest;
};

module.exports = {

    /**
     * Changed window object to parameter for easier testing
     * @param {object} win Mock window object
     * @param {object} uri Mock object mainly for testing
     */
    init: function checkForAuthModal(win, uri) {
        var winObj = win && win.location ? win : window;
        var uriObj = uri && uri.path ? uri : parseUri;
        var destination = getRedirectDestination(uriObj);
        var action = uriObj.queryKey.modal || '';
        var gaAction = action.replace('_', ' ');
        var authOptions;
        action = action.replace('_', '-');
        authOptions = {
            action: action,
            ga: {
                label: gaAction + ' query param - address bar',
                value: helpers.getHasScrolled() ? 1 : 0
            }
        };

        if (action) {
            if (winObj.testMode) {
                // since the authModal requires a user action in order for the
                // promise to fire, the href required for testing will never be updated
                // TODO: jasmine testing + resolving promises
                winObj.location.href = destination;

            } else if (authModals.indexOf(action) > -1) {
                // Need to make sure we have fresh user state
                // and don't get into infinite redirect loops
                User.load()
                    .then(function () {
                        if (destination) {
                            winObj.location.href = destination;
                        }
                    })
                    .fail(function () {
                        if (SV.settings.fireGaPageViewOnAuthModalClose) {
                            $.publish('ga:pageView');
                        }

                        authModalLoader.show(authOptions).then(function (authResponse) {
                            if (destination && !authResponse.err) {
                                winObj.location.href = destination;
                            }
                        });
                    });
            }
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/nav/authModalCheck.js
// module id = 2569
// module chunks = 64